import { render, staticRenderFns } from "./InputBPJSCapitation.vue?vue&type=template&id=4a274777&scoped=true"
import script from "./InputBPJSCapitation.vue?vue&type=script&lang=js"
export * from "./InputBPJSCapitation.vue?vue&type=script&lang=js"
import style0 from "./InputBPJSCapitation.vue?vue&type=style&index=0&id=4a274777&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4a274777",
  null
  
)

export default component.exports